import { Card, Row, Col, Statistic } from "antd";
import { ShoppingOutlined, CheckCircleOutlined } from "@ant-design/icons";
import CountUp from "react-countup";

const DashboardCards = ({ todayOrders, assignedOrders, orders, CompleteOrder }) => {
    const formatter = (value) => <CountUp end={value} duration={1.5} separator="," />;

    return (
        <div style={{ marginBottom: 12 }}>
            <Row gutter={[12, 12]}>
                <Col xs={24} sm={12} md={6}>
                    <Card size="small" style={{ borderRadius: 12, border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                        <Statistic
                            title="All Orders"
                            value={orders}
                            formatter={formatter}
                            valueStyle={{ color: "#3b82f6", fontSize: 18 }}
                            prefix={<ShoppingOutlined style={{ fontSize: 18, color: "#3b82f6" }} />}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card size="small" style={{ borderRadius: 12, border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                        <Statistic
                            title="Today"
                            value={todayOrders}
                            formatter={formatter}
                            valueStyle={{ color: "#f59e0b", fontSize: 18 }}
                            prefix={<ShoppingOutlined style={{ fontSize: 18, color: "#f59e0b" }} />}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card size="small" style={{ borderRadius: 12, border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                        <Statistic
                            title="Assigned"
                            value={assignedOrders}
                            formatter={formatter}
                            valueStyle={{ color: "#22c55e", fontSize: 18 }}
                            prefix={<CheckCircleOutlined style={{ fontSize: 18, color: "#22c55e" }} />}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card size="small" style={{ borderRadius: 12, border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                        <Statistic
                            title="Complete"
                            value={CompleteOrder}
                            formatter={formatter}
                            valueStyle={{ color: "#16a34a", fontSize: 18 }}
                            prefix={<CheckCircleOutlined style={{ fontSize: 18, color: "#16a34a" }} />}
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default DashboardCards;
